import { useRef } from 'react'
import { useAuthStore } from '../store/authStore'

import { useLayoutStore } from '../store/layoutStore'
// import Footer from './footer'
import HeaderTop from './headerTop'
import { ScrollProvider } from './scrollcontext'
// import Overview from '../components/common/overview/overview'
// import SideNav from './sidenav'
import SideNav from './sidenav'
import ImpersonateBar from './impersonateBar'

// type LayoutType = 'headerNav' | 'sideNav'

export default function Layout({ children }: any) {
  // let layoutType: LayoutType = 'headerNav'
  const {
    impersonating,
    // token
  } = useAuthStore()
  const { layoutType, expand } = useLayoutStore()
  const mainRef = useRef(null)

  return (
    <div
      className={`flex bg-mainBgColor h-screen  ${layoutType === 'sideNav' ? 'visible-screen' : 'pt-[56px]'}`}
    >
      <HeaderTop />

      <div className="flex-1 flex  overflow-hidden relative">
        {layoutType === 'sideNav' && <SideNav />}

        <ScrollProvider value={mainRef}>
          <div
            className={`flex h-full w-full overflow-auto flex-col duration-300   ${layoutType === 'sideNav' ? (expand ? 'expand-sidebar-spacing' : 'collapse-sidebar-spacing') : ''}`}
          >
            {impersonating && <ImpersonateBar />}

            <main
              ref={mainRef}
              className={` bg-maingradient flex flex-col h-full w-full overflow-x-hidden overflow-y-auto`}
            >
              {children}
            </main>
            {/* <Footer /> */}
          </div>
        </ScrollProvider>
      </div>
    </div>
  )
}
